import React from 'react';
import { Artwork } from '../../types/Artwork';
import { ImageCard } from './ImageCard';

interface GalleryListProps {
    artworks: Artwork[];
    sectionPath: string[];
}

// Mobile gallery: a single vertical column of all the section's works,
// lazy-loaded via ImageCard, with no pager.
export const GalleryList = ({ artworks, sectionPath }: GalleryListProps) => (
    <ul className="flex flex-col gap-6">
        {artworks.map((artwork) => (
            <li key={artwork.id}>
                <ImageCard artwork={artwork} sectionPath={sectionPath} />
            </li>
        ))}
    </ul>
);
